<template>
  <div>
    <v-card class="pt-4 pb-5">
      <b-row>
        <b-col cols="2">
          <label class="pt-4 float-right defaultLabel"> Typ: </label>
        </b-col>
        <b-col cols="8">
          <label class="pt-4 defaultLabel">
            {{ typeDisplay }}
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label class="pt-4 float-right defaultLabel"> Bezeichnungen: </label>
        </b-col>
        <b-col cols="8">
          <v-text-field
            v-model="valueDe"
            label="Deutsch"
            @input="updateContent"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="2" />
        <b-col cols="8">
          <v-text-field
            v-model="valueFr"
            label="Französisch"
            @input="updateContent"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2" />
        <b-col cols="8">
          <v-text-field
            v-model="valueIt"
            label="Italienisch"
            @input="updateContent"
          />
        </b-col>
      </b-row>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    wageSupplementTypeConfiguration: {
      type: Object,
      required: true,
    },
    wageSupplementTypes: {
      type: Array,
      default: () => [],
    },
    contentsField: {
      type: String,
      default: "wageSupplementTypeConfigurationContents",
    },
    textField: {
      type: String,
      default: "text",
    },
    typeField: {
      type: String,
      default: "wageSupplementType",
    },
  },
  data() {
    return {
      selectedWageSupplementType: 0,
      valueDe: "",
      valueFr: "",
      valueIt: "",
    };
  },
  computed: {
    typeDisplay() {
      let type = this.wageSupplementTypes.find(
        (type) =>
          type.id == this.wageSupplementTypeConfiguration[this.typeField],
      );
      if (type) {
        return type[this.textField];
      }
      return "";
    },
  },
  watch: {
    wageSupplementTypeConfiguration: function (newVal) {
      this.setTypeConfigurationFields(newVal);
    },
  },
  created() {
    this.setTypeConfigurationFields(this.wageSupplementTypeConfiguration);
  },
  methods: {
    setTypeConfigurationFields(config) {
      this.selectedWageSupplementType = config[this.typeField];
      if (config[this.contentsField]) {
        config[this.contentsField].map((content) => {
          if (content.language == "de-CH") {
            this.valueDe = content.value;
          } else if (content.language == "fr-CH") {
            this.valueFr = content.value;
          } else if (content.language == "it-CH") {
            this.valueIt = content.value;
          }
        });
      }
    },
    updateContent() {
      let content = [
        {
          id: 0,
          wageSupplementTypeConfigurationId:
            this.wageSupplementTypeConfiguration.id,
          value: this.valueDe,
          language: "de-CH",
        },
        {
          id: 0,
          wageSupplementTypeConfigurationId:
            this.wageSupplementTypeConfiguration.id,
          value: this.valueFr,
          language: "fr-CH",
        },
        {
          id: 0,
          wageSupplementTypeConfigurationId:
            this.wageSupplementTypeConfiguration.id,
          value: this.valueIt,
          language: "it-CH",
        },
      ];

      this.$emit("inputContent", content);
    },
    updateWageSupplementType() {
      this.$emit("inputZuschlagstyp", this.selectedWageSupplementType);
    },
  },
};
</script>

<style scoped></style>
